import {
  Separator as ChakraDivider,
  type SeparatorProps as ChakraDividerProps,
} from "@chakra-ui/react";
import type { DividerSharedProps } from "./Divider.props";

export default function Divider({
  orientation,
  ...props
}: DividerProps): JSX.Element {
  return (
    <ChakraDivider borderColor="border" orientation={orientation} {...props} />
  );
}

export type DividerProps = DividerSharedProps & ChakraDividerProps;
